/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { COMPONENTS_CODE } from '../../assets/ts/data/common-metadata'
import { convertDate, formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import useCalendar from '../../hooks/use-calendar'
import { MetadataContext } from '../../store/metadata-context-provider'
import { ALL_SELECT_LABEL, ALL_SELECT_OPTION, ALL_SELECT_VALUE } from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import { Dropdown, homeSection, optionsTypes } from '../../utils/controls/select-options-data'
import './calendar.css'
import { AllPrograms } from './calendar-data'

interface DashboardCalendar {
  assignComponentCode: number
  categoryCode: number
  content: string
  date: string
  description: string
  eKey: string
  endtime: string
  extra: string
  id: string
  link: string
  location: string
  majcomCode: number
  month: string
  section: string
  sectionCode: number
  starttime: string
  subcontent: string
  subcontent1: string
  title: string
}

interface CalendarProps {
  CategoryOptions: optionsTypes[]
  SectionOptions: optionsTypes[]
  filterCategoryValue?: Dropdown
  filterComponentValue?: Dropdown
  filterMajcomValue?: Dropdown
  filterSectionValue?: Dropdown
  isFilters?: boolean
  setCategoryValue?: () => void,
  setSectionValue?: () => void,
}

const HomeCalendar = (props: CalendarProps) => {
  const {
    CategoryOptions,
    SectionOptions,
    filterCategoryValue,
    filterComponentValue,
    filterMajcomValue,
    filterSectionValue,
    isFilters, //shows inner component filters
    setCategoryValue,
    setSectionValue,
  } = props

  const { CalendarData } = useCalendar({
    isArchived: false,
  })

  const [intialCalendarEvents, setIntialCalendarEvents] = useState<Array<DashboardCalendar>>([])
  const [filteredCalendarEvents, setFilteredCalendarEvents] = useState<Array<DashboardCalendar>>([])

  const [filterValues, setFilterValues] = useState({
    assignedComponent: COMPONENTS_CODE.Regular_Air_Force_LABEL,
    assignedComponentCode: COMPONENTS_CODE.Regular_Air_Force,
    category: ALL_SELECT_LABEL,
    categoryCode: ALL_SELECT_VALUE,
    majcom: ALL_SELECT_LABEL,
    majcomCode: ALL_SELECT_VALUE,
    section: ALL_SELECT_LABEL,
    sectionCode: ALL_SELECT_VALUE,
  })

  useEffect(() => {
    if (!isFilters) {
      const newAnnouncements = intialCalendarEvents?.filter(
        ({ assignComponentCode, majcomCode, sectionCode }) => {
          return (
            filterBy(assignComponentCode, filterComponentValue?.value as number) &&
            filterBy(majcomCode, filterMajcomValue?.value as number) &&
            filterBy(sectionCode, filterSectionValue?.value as number)
          )
        }
      )
      setFilteredCalendarEvents(newAnnouncements)
    }
  }, [
    intialCalendarEvents,
    filterSectionValue?.value,
    filterMajcomValue?.value,
    filterCategoryValue?.value,
    filterComponentValue?.value,
  ])

  function codesNullHandler(code: number) {
    return code ? code : -1
  }
  useEffect(() => {
    if (CalendarData.length > 0) {
      const homeCalendar: DashboardCalendar[] = CalendarData?.map((item) => ({
        assignComponentCode: codesNullHandler(item.AssignedComponentCode as number),
        category: item.Category,
        date: convertDate(item.StartDate, 'Day'), //'12',
        description: item.Description, //'location: Andrews AFB, Maryland, United States',
        endtime: `to ${convertDate(item.EndDate, 'Time')}`,
        id: item.Category,
        link: '/',
        location: item.Location,
        majcomCode: codesNullHandler(item.MAJCOMCode),
        month: convertDate(item.StartDate, 'Month'), // 'SEP',
        section: item.Section,
        sectionCode: codesNullHandler(item.SectionCode as number),
        starttime: convertDate(item.StartDate, 'Time'), //'11.30 AM',
        title: item.Title, //'MPF DEMO - SAF/FM Leadership',
      }))
      setIntialCalendarEvents(homeCalendar)
      setFilteredCalendarEvents(homeCalendar)
    }
  }, [CalendarData])
  const indicatorColor = (event: string): number => {
    const eventColors = {
      Events: 1,
      Meeting: 3,
      Trainings: 2,
    }
    return eventColors[event] || 1
  }
  const onChangeSection = (e: { label: string; value: number }) => {
    const newCalendarEvents = intialCalendarEvents?.filter(({ sectionCode }) => {
      return filterBy(sectionCode, e.value)
    })
    setFilteredCalendarEvents(newCalendarEvents)
    setFilterValues((prev) => ({
      ...prev,
      section: e.label,
      sectionCode: e.value,
    }))
    
    setSectionValue({ label: e.label, value: e.value })
    setCategoryValue(ALL_SELECT_OPTION)
  }

  function filterBy(value: number, filter: number) {
    return filter === ALL_SELECT_VALUE || value === filter || value === ALL_SELECT_VALUE
  }

  return (
    <>
      <div className='d-flex align-items-center pb-0 card-header'>
        <div className='d-flex mb-1 title-border'>
          <h2 aria-label='Calendar' className='poppins-bold font-14 title-color20' tabIndex={0}>
            Calendar
          </h2>
        </div>
        <div className='ms-auto d-flex flex-wrap align-items-center'>
          {/* for customer view */}
          {isFilters && (
            <div className='mx-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-11'
                id='Section'
                label='Section'
                menuPlacement={'auto'}
                menuPortalTarget={undefined}
                menuPosition={'fixed'}
                minMenuHeight={0}
                name='Section'
                onChange={onChangeSection}
                options={SectionOptions}
                value={filterValues.sectionCode}
              />
            </div>
          )}
          <Link
            className='links-over-underline font-12 links ms-1'
            title='View All'
            to={`${ROUTE_TYPE}calendar`}
          >
            View All
          </Link>
        </div>
      </div>
      <div className='d-flex flex-column card-body py-2'>
        <div>
          <ul className='calendar-item-type py-2 poppins-medium font-11 title-color11'>
            <li aria-label='Events' className='dots dots-color1 pe-2' tabIndex={0}>
              Events
            </li>
            <li aria-label='Trainings' className='dots dots-color2 pe-2' tabIndex={0}>
              Trainings
            </li>
            <li aria-label='Meetings' className='dots dots-color3 pe-2' tabIndex={0}>
              Meetings
            </li>
          </ul>
        </div>

        {filteredCalendarEvents.length === 0 ? (
          <NO_RESULTS />
        ) : (
          filteredCalendarEvents.slice(0, 3).map((items) => (
            <div
              className={`mb-2 calenderlist bordered1 dots-color${indicatorColor(
                items.id
              )} border-radius1 py-3 pe-3 dots d-flex p-relative`}
              id={items.id}
              key={items.title}
              title={items.id}
            >
              <div
                aria-label={items.date}
                className='p-2 py-1 border-right2 me-3 title-color8 mb-1 montserratbold text-center'
                tabIndex={0}
              >
                <p>{items.date}</p>
                <p>{items.month}</p>
              </div>
              <div aria-live='polite' className='meetings-border-left' tabIndex={0}>
                <div className='title-color1 font-13 poppins-semibold '>{items.title}</div>
                <div className='title-color45 poppins-semibold font-13'>
                  Location: {items.location} | Time: {items.starttime} {items.endtime}
                </div>
              </div>

              <div className='calendarpopup'>
                <div className='arrow'></div>
                <div className='calendarpopupinfo'>
                  <h2
                    aria-label={items.title}
                    className='title-color1 font-13 poppins-semibold'
                    tabIndex={0}
                  >
                    {items.title}
                  </h2>
                  <div className='divcalendarinfo w-100 position-relative'>
                    <ul className='m-0 p-0 w-100 list-type-none title-color45 poppins-semibold font-11'>
                      <li className='mb-1'>
                        Start Time: <span>{items.starttime}</span>
                      </li>
                      <li className='mb-1'>
                        End Time: <span>{items.endtime}</span>
                      </li>
                      <li className='mb-1'>
                        Location: <span>{items.location}</span>
                      </li>
                    </ul>
                    <h3
                      aria-label='Description'
                      className='title-color45 poppins-semibold font-11'
                      tabIndex={0}
                    >
                      Description:
                    </h3>
                    <p
                      aria-label={items.description}
                      className='title-color45 poppins-semibold font-11'
                      tabIndex={0}
                    >
                      {items.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  )
}
export default HomeCalendar
